// src/pages/auth/GoogleCallback.js
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getCurrentUser } from '../../services/api.js';
import LoadingSpinner from '../../components/common/LoadingSpinner.js';

export const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      console.log('GoogleCallback: Processing callback', { 
        hasToken: !!token, 
        hasError: !!error,
        tokenLength: token?.length 
      });

      if (error) {
        console.error('Google OAuth error:', error);
        navigate('/login?error=google_auth_failed');
        return;
      }

      if (token) {
        try {
          console.log('GoogleCallback: Storing token and fetching user data...');
          
          // Store token
          localStorage.setItem('token', token);
          
          // Get user data using the existing API function
          console.log('GoogleCallback: Calling getCurrentUser()...');
          const userData = await getCurrentUser();
          console.log('GoogleCallback: User data received:', { 
            email: userData?.email, 
            id: userData?._id 
          });
          
          // Store user data
          localStorage.setItem('user', JSON.stringify({ ...userData, token }));
          
          console.log('GoogleCallback: Redirecting to dashboard...');
          // Reload the page to refresh auth context
          window.location.href = '/dashboard';
        } catch (error) {
          console.error('Error processing Google OAuth callback:', error);
          console.error('Error details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
          });
          localStorage.removeItem('token');
          navigate('/login?error=google_auth_failed');
        }
      } else {
        console.error('GoogleCallback: No token received');
        navigate('/login?error=google_auth_failed');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-blue-50/30 to-indigo-50/30">
      <div className="text-center">
        <LoadingSpinner message="Completing sign in..." />
      </div>
    </div>
  );
};

export default GoogleCallback;

